/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { CheckCircle, Pause, Play } from "phosphor-react";
import { Howl } from "howler";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import { changePlayingAudioUrl } from "redux/actions/pages";
import { connect } from "react-redux";

const RecordTableCell = ({ audioUrl, localizations, playingAudioUrl, setPlayingAudioUrl }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [audio, setAudio] = useState(null);
  const [loading, setLoading] = useState(false);

  const mounted = useRef(false);

  useEffect(() => {
    mounted.current = true;
    return () => {
      if (audio) audio.unload();
      mounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (isPlaying) {
      audio?.play();
    } else {
      audio?.pause();
      if (audio) {
        if (mounted.current === true) setPlayingAudioUrl("");
      }
    }
  }, [isPlaying, audio]);

  return (
    <SuiBox display="flex" alignItems="center">
      <CheckCircle size={28} color="#82D616" weight="duotone" />
      <SuiBox
        pl={1}
        style={{ cursor: "pointer" }}
        onClick={() => {
          if (playingAudioUrl !== "" && playingAudioUrl !== audioUrl) {
            return;
          }

          if (!isPlaying) {
            if (!audio) {
              if (mounted.current === true) setLoading(true);
              const newSound = new Howl({
                src: audioUrl,
                preload: true,
                onload: () => {
                  if (mounted.current === true) setLoading(false);
                },
              });

              newSound.once("end", () => {
                if (mounted.current === true) {
                  setIsPlaying(false);
                  setAudio(null);
                  setPlayingAudioUrl("");
                }
              });
              if (mounted.current === true) setAudio(newSound);
            }

            if (mounted.current === true) {
              setPlayingAudioUrl(audioUrl);
              setIsPlaying(true);
            }
          } else if (mounted.current === true) setIsPlaying(false);
        }}
      >
        <SuiTypography
          variant="button"
          color="secondary"
          sx={{ display: "inline-block", width: "max-content" }}
        >
          {isPlaying
            ? loading
              ? "Yükleniyor..."
              : localizations?.PAUSE_BTN ?? <Pause size={28} weight="duotone" />
            : localizations?.PLAY_BTN ?? <Play size={28} weight="duotone" />}
        </SuiTypography>
      </SuiBox>
    </SuiBox>
  );
};

RecordTableCell.defaultProps = {
  localizations: null,
  audioUrl: null,
  playingAudioUrl: "",
};

RecordTableCell.propTypes = {
  localizations: PropTypes.objectOf(PropTypes.any),
  audioUrl: PropTypes.string,
  playingAudioUrl: PropTypes.string,
  setPlayingAudioUrl: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  localizations: state.localization?.pairs,
  playingAudioUrl: state.data?.playingAudioUrl,
});

const mapDispatchToProps = {
  setPlayingAudioUrl: changePlayingAudioUrl,
};

export default connect(mapStateToProps, mapDispatchToProps)(RecordTableCell);
